import { APP_PERMISSIONS } from '@exam-management/permissions';
import { QSetActivityLogList } from '@exam-management/qset-activity-log-list';
import { Flex, PaperSection } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function QSetActivityLogPage() {
  return (
    <PermissionGuard requiredPermission={[APP_PERMISSIONS.EXAM.AUDIT_LOG.VIEW]}>
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          width: '100%',
          p: theme.spacing(6),
        })}
      >
        <Flex>
          <PaperSection title='Activity Log'>
            <Flex
              sx={(theme) => ({
                flexDirection: 'column',
                p: theme.spacing(6),
                gap: theme.spacing(6),
              })}
            >
              <QSetActivityLogList />
            </Flex>
          </PaperSection>
        </Flex>
      </Flex>
    </PermissionGuard>
  );
}
